import React, { useEffect } from "react";
import ButtonT from "../../components/atoms/ButtonT";
import InputGroup from "../../components/atoms/InputGroup";
import Title from "../../components/atoms/Title";
import TitleDetail from "../../components/atoms/TitleDetail";
import Navbar from "../../components/main/Navbar";

import { useStateContext } from "../../context/AdminDashboard/ModelsAddEditContext";

import SelectModal from "../../components/atoms/SelectModal";

import { Toaster } from "react-hot-toast";
import ParentComponent from "../../components/deviceModels/Dynamic";
import NumberInputWithCommas from "../../components/deviceModels/InputPrice";

const ModelsAdd = ({}) => {
  const {
    changeConnection,
    onchangeInput,
    changehealthrules,
    changeenvironment,
    changeuseType,
    changetestType,
    changeprotocol,
    changespeakertype,
    changelighttype,
    onchangerele,
    serialnumber,
    price,

    environmentvalue,
    useTypevalue,
    testTypevalues,
    protocolvalues,
    healthrulesvalue,
    connectionType,
    speakertypevalue,
    lighttypevalue,
    relestatusvalue,
    handleFormSubmit,
    handledoneedit,
    formattedNumber, setFormattedNumber, handlepriceChange
  } = useStateContext();

  return (
    <>
      <div className="pb-7.5px">
        <Navbar titles={["دستگاه‌ها", "فهرست مدل‌ها", "افزودن مدل جدید"]} />

        <div
          className="mr-7.5px ml-7.5px mt-5 bg-white shadow-md rounded-sm pr-7.5px pl-7.5px pt-7.5px  "
          dir="rtl">
          <div className="flex flex-row justify-between items-center h-10  ">
            <div className="flex flex-row ">
              <Title text="افزودن مدل جدید" />
            </div>
            <ButtonT
              text={"برگشت به لیست"}
              path={"/admin/device/models"}
              link={true}
            />
          </div>
          <TitleDetail title={"اطلاعات کلی مدل"} />
          <div className="flex flex-row justify-between w-full gap-5 mt-25">
            <InputGroup
              icon={false}
              label={"نام نمایشی"}
              id={"username"}
              onchange={onchangeInput}
              placeholder="مانند دما رطوبت"
              onchangeAble={true}
            />
            <InputGroup
              icon={false}
              label={"پیش نمایش شماره سریال"}
              id={"serialNumber"}
              value={serialnumber}
              placeholder="شماره سری  و شماره اپدیت را وارد کنید"
              onchangeAble={false}
            />
            {/* <InputGroup
              icon={false}
              label={" قیمت (تومان)"}
              id={"price"}
              onchange={onchangeInput}
              placeholder=" مانند 6,000,000"
              onchangeAble={true}
              vel={price}
              
            /> */}
            <NumberInputWithCommas 
            formattedNumber={formattedNumber}
            setFormattedNumber={setFormattedNumber}
            handlepriceChange={handlepriceChange} />
          </div>
          <div className="flex flex-row justify-between w-full gap-5 mt-25">
            <InputGroup
              icon={false}
              label={"نام سری"}
              id={"seriname"}
              onchange={onchangeInput}
              placeholder=" مانند CO2-MW"
              onchangeAble={true}
              width={"w-1/4"}
            />
            <InputGroup
              icon={false}
              label={"شماره آپدیت"}
              id={"updatenumbr"}
              onchange={onchangeInput}
              placeholder="V-05 مانند"
              onchangeAble={true}
              width={"w-1/4"}
            />
            <SelectModal
              icon={false}
              label={"محیط سنجش"}
              style={"w-1/4 justify-between"}
              values={environmentvalue}
              onchange={changeenvironment}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={true}
              maxWidth="256px"
              minWidth={"150px"}
              stylebox={"pl-0"}
            />
            <SelectModal
              icon={false} // style={"w-1/4 justify-between"}
              label={"نوع استفاده"}
              values={useTypevalue}
              onchange={changeuseType}
              placeholder={"یک گزینه را انتخاب کنید"}
              style={"w-1/4 justify-between"}
              maxWidth="256px"
              minWidth={"150px"}
              able={true}
              stylebox={"pl-0"}
            />
          </div>
          <div className="flex flex-row justify-between w-full gap-5 mt-25">
            <SelectModal
              icon={false}
              label={"نوع سنجش"}
              style={"w-1/4 justify-between"}
              values={testTypevalues}
              onchange={changetestType}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={true}
              maxWidth="256px"
              minWidth={"150px"}
              stylebox={"pl-0"}
            />
            <SelectModal
              icon={false}
              label={"پروتکل اتصال"}
              style={"w-1/4 justify-between"}
              values={protocolvalues}
              onchange={changeprotocol}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={true}
              maxWidth="256px"
              minWidth={"150px"}
              stylebox={"pl-0"}
            />
            <SelectModal
              icon={false}
              label={"قوانین بهداشتی"}
              style={"w-1/4 justify-between"}
              values={healthrulesvalue}
              onchange={changehealthrules}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={true}
              maxWidth="256px"
              minWidth={"150px"}
              stylebox={"pl-0"}
            />
            <SelectModal
              icon={false}
              label={"نوع اتصال به برق"}
              style={"w-1/4 justify-between"}
              values={connectionType}
              onchange={changeConnection}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={true}
              maxWidth="256px"
              minWidth={"150px"}
              stylebox={"pl-0"}
            />
          </div>
          <div className="flex flex-row justify-between w-full gap-5 mt-25">
            <SelectModal
              icon={false}
              label={"وضعیت بلندگو"}
              style={"w-1/3 justify-between"}
              values={speakertypevalue}
              onchange={changespeakertype}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={true}
              maxWidth="256px"
              minWidth={"150px"}
              stylebox={"pl-0"}
            />
            <SelectModal
              icon={false}
              label={"وضعیت چراغ‌ها‌"}
              style={"w-1/3 justify-between"}
              values={lighttypevalue}
              onchange={changelighttype}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={true}
              maxWidth="256px"
              minWidth={"150px"}
              stylebox={"pl-0"}
            />
            <SelectModal
              icon={false}
              label={"وضعیت رِله"}
              style={"w-1/3 justify-between"}
              values={relestatusvalue}
              onchange={onchangerele}
              placeholder={"یک گزینه را انتخاب کنید"}
              able={true}
              maxWidth="256px"
              minWidth={"150px"}
              stylebox={"pl-0"}
            />
          </div>
          {/* <ParentComponent/> */}
          <ParentComponent submit={handleFormSubmit} />
          <Toaster />
        </div>
      </div>
    </>
  );
};

export default ModelsAdd;
